import { buttonVariants } from "./button";
import { pillVariants } from "./pill";
import { HINT_CLASS } from "./empty-state";
import { SECTION_HEADER_CLASS } from "./section-header";

/**
 * The UI vocabulary as class strings, for places that style a native element (a <li>, a <summary>, a <span role=button>)
 * and so cannot be a <Button>/<Pill>. They are built FROM the same cva definitions — there is no second copy to drift:
 * the letopis panel and the remarks panel used to declare their own BTN* sets, and the two had already diverged.
 */
export const BTN = buttonVariants({ variant: "outline", size: "sm" });
export const BTN_OK = buttonVariants({ variant: "ok", size: "sm" });
export const BTN_PRIMARY = buttonVariants({ size: "sm" });
/** `.btn.ghost`: the quiet accent text link. */
export const BTN_GHOST = buttonVariants({ variant: "text", size: "inline" });
/** `.btn.ghost` that asks for a last confirmation ("Really delete?"). */
export const BTN_GHOST_DESTRUCTIVE = buttonVariants({ variant: "textDanger", size: "inline" });
/** `.icon`: a 28x26 square (⌕ ＋ ⋯). */
export const ICON = `relative ${buttonVariants({ variant: "outline", size: "icon" })} text-muted-foreground hover:text-fg`;
export const PILL_DRAFT = pillVariants({ tone: "draft" });
export const PILL_GUESS = pillVariants({ tone: "guess" });
export const H = SECTION_HEADER_CLASS;
export const HINT = HINT_CLASS;
